"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[22982],{

/***/ 47858:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgFacebook = function SvgFacebook(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m17.093 13.374.626-3.98h-3.858V6.809c0-1.088.538-2.152 2.26-2.152h1.78v-3.39A21.563 21.563 0 0 0 14.769 1C11.593 1 9.52 2.909 9.52 6.36v3.035H6v3.98h3.52V23h4.34v-9.626h3.233Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgFacebook);

/***/ }),

/***/ 78323:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path, _path2;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgMail = function SvgMail(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2Z",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "m22 6-10 7L2 6",
    stroke: "currentColor",
    strokeWidth: 1.4,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgMail);

/***/ }),

/***/ 41829:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11720);
var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }



var SvgTwitter = function SvgTwitter(props) {
  return /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    role: "img"
  }, props), _path || (_path = /*#__PURE__*/react__WEBPACK_IMPORTED_MODULE_0__.createElement("path", {
    d: "M22.902 5.18c-.712.307-1.46.52-2.226.636.358-.062.885-.707 1.095-.968a4.1 4.1 0 0 0 .717-1.327c0-.036.035-.087 0-.113a.123.123 0 0 0-.118 0 11.28 11.28 0 0 1-2.635 1.025.184.184 0 0 1-.185-.046 2.566 2.566 0 0 0-.23-.241 4.8 4.8 0 0 0-1.259-.814 4.423 4.423 0 0 0-1.96-.323 4.74 4.74 0 0 0-1.862.512 4.827 4.827 0 0 0-1.474 1.25 4.734 4.734 0 0 0-.896 1.792 4.927 4.927 0 0 0-.046 1.895c0 .108 0 .123-.092.108C8.083 8.028 5.09 6.732 2.643 3.95c-.107-.123-.164-.123-.25 0-1.065 1.619-.548 4.18.782 5.445.18.169.364.333.558.486a4.566 4.566 0 0 1-1.75-.486c-.102-.067-.159-.031-.164.092-.014.17-.014.342 0 .512a4.653 4.653 0 0 0 2.866 3.708c.186.08.38.14.578.18a5.229 5.229 0 0 1-1.714.05c-.123-.025-.169.042-.123.16.752 2.048 2.385 2.673 3.582 3.021.164.026.328.026.512.067l-.03.03c-.354.646-1.782 1.081-2.437 1.307a8.748 8.748 0 0 1-3.735.481c-.2-.03-.246-.026-.297 0-.051.026 0 .082.056.133.256.17.512.318.778.461a12.2 12.2 0 0 0 2.497 1.024c4.493 1.24 9.549.328 12.921-3.026 2.651-2.633 3.582-6.264 3.582-9.9 0-.139.17-.221.266-.293a8.792 8.792 0 0 0 1.756-1.833.538.538 0 0 0 .122-.369c0-.077 0-.061-.097-.02Z",
    fill: "currentColor"
  })));
};

/* harmony default export */ __webpack_exports__["default"] = (SvgTwitter);

/***/ }),

/***/ 22982:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

// ESM COMPAT FLAG
__webpack_require__.r(__webpack_exports__);

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "default": function() { return /* binding */ modal_gallery; }
});

// EXTERNAL MODULE: ./node_modules/preact/compat/jsx-runtime.mjs + 1 modules
var jsx_runtime = __webpack_require__(97997);
// EXTERNAL MODULE: ./node_modules/preact/compat/dist/compat.module.js + 1 modules
var compat_module = __webpack_require__(11720);
// EXTERNAL MODULE: ./node_modules/next/dynamic.js
var dynamic = __webpack_require__(5152);
var dynamic_default = /*#__PURE__*/__webpack_require__.n(dynamic);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/transitions/transition.js + 3 modules
var transition = __webpack_require__(11355);
// EXTERNAL MODULE: ./node_modules/@headlessui/react/dist/components/dialog/dialog.js + 9 modules
var dialog = __webpack_require__(46571);
// EXTERNAL MODULE: ./components/icons/light/chevron-left.svg
var chevron_left = __webpack_require__(30282);
// EXTERNAL MODULE: ./components/icons/light/facebook.svg
var facebook = __webpack_require__(47858);
// EXTERNAL MODULE: ./components/icons/light/mail.svg
var mail = __webpack_require__(78323);
// EXTERNAL MODULE: ./components/icons/light/twitter.svg
var twitter = __webpack_require__(41829);
// EXTERNAL MODULE: ./components/atoms/button/index.ts + 1 modules
var atoms_button = __webpack_require__(74388);
// EXTERNAL MODULE: ./components/atoms/button/types.ts
var types = __webpack_require__(90891);
;// CONCATENATED MODULE: ./components/atoms/modal-gallery/ModalGallery.tsx










const ModalShare = dynamic_default()(()=>__webpack_require__.e(/* import() */ 77520).then(__webpack_require__.bind(__webpack_require__, 77520)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(77520)
            ]
    },
    ssr: true
});
const ModalForm = dynamic_default()(()=>__webpack_require__.e(/* import() */ 42941).then(__webpack_require__.bind(__webpack_require__, 42941)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(42941)
            ]
    },
    ssr: true
});
const FormsTabs = dynamic_default()(()=>__webpack_require__.e(/* import() */ 16860).then(__webpack_require__.bind(__webpack_require__, 16860)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(16860)
            ]
    },
    ssr: true
});
const ContactForm = dynamic_default()(()=>Promise.all(/* import() */[__webpack_require__.e(79375), __webpack_require__.e(33895)]).then(__webpack_require__.bind(__webpack_require__, 77590)), {
    loadableGenerated: {
        webpack: ()=>[
                /*require.resolve*/(77590)
            ]
    },
    ssr: true
});
const ModalGallery = (param)=>{
    let { children , isOpen =true , closeModal , className ="" , flat , isViewForms =true , unmount =false  } = param;
    const [url, setUrl] = (0,compat_module.useState)("");
    const [isOpenContactForm, setIsOpenContactForm] = (0,compat_module.useState)(false);
    (0,compat_module.useEffect)(()=>{
        setUrl(document.URL);
        return ()=>setUrl("");
    }, []);
    return /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transition/* Transition */.u, {
        appear: true,
        show: isOpen,
        as: compat_module.Fragment,
        unmount: unmount,
        children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dialog/* Dialog */.V, {
            as: "div",
            className: "relative z-20",
            onClose: closeModal,
            unmount: false,
            children: [
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transition/* Transition.Child */.u.Child, {
                    unmount: false,
                    as: compat_module.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0",
                    enterTo: "opacity-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100",
                    leaveTo: "opacity-0",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                        className: "fixed inset-0 bg-neutrals-900 bg-opacity-40"
                    })
                }),
                /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(transition/* Transition.Child */.u.Child, {
                    unmount: false,
                    as: compat_module.Fragment,
                    enter: "ease-out duration-300",
                    enterFrom: "opacity-0 scale-95",
                    enterTo: "opacity-100 scale-100",
                    leave: "ease-in duration-200",
                    leaveFrom: "opacity-100 scale-100",
                    leaveTo: "opacity-0 scale-95",
                    children: /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)(dialog/* Dialog.Panel */.V.Panel, {
                        className: "bg-white shadow-xl fixed inset-0 my-auto flex w-full transform flex-col overflow-hidden bg-neutrals-0 text-left transition-all lg:h-max lg:max-h-[calc(100vh-32px)] ".concat(className),
                        children: [
                            /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "sticky left-0 right-0 top-0 z-40 flex justify-between bg-neutrals-0 py-5 px-4 drop-shadow-[0_4px_12px_rgba(13,31,35,0.16)] lg:drop-shadow-none",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("button", {
                                        type: "button",
                                        onClick: closeModal,
                                        className: "focus-visible:outline-none focus-visible:ring-0 focus-visible:ring-offset-0",
                                        children: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(chevron_left["default"], {
                                            width: 24,
                                            height: 24
                                        })
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalShare, {
                                        className: "order-3 lg:order-2",
                                        title: "Comparte esta vivienda",
                                        socialMedias: [
                                            {
                                                Icon: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(mail["default"], {
                                                    width: 32,
                                                    heigth: 32
                                                }),
                                                text: "Email",
                                                href: "mailto:?subject=Feedback&body=Message"
                                            },
                                            {
                                                Icon: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(twitter["default"], {
                                                    width: 32,
                                                    heigth: 32
                                                }),
                                                text: "Twitter",
                                                href: "https://twitter.com/intent/tweet?url=".concat(url)
                                            },
                                            {
                                                Icon: /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(facebook["default"], {
                                                    width: 32,
                                                    heigth: 32
                                                }),
                                                text: "Facebook",
                                                href: "https://www.facebook.com/sharer.php?u=".concat(url)
                                            }
                                        ],
                                        gtm: {
                                            itemId: flat === null || flat === void 0 ? void 0 : flat.codigoUnidadAlquiler
                                        }
                                    })
                                ]
                            }),
                            /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)("div", {
                                className: "text-gray-500 relative mt-4 flex-grow px-4 text-sm lg:mt-0 lg:h-auto",
                                children: children
                            }),
                            isViewForms && /*#__PURE__*/ (0,jsx_runtime/* jsxs */.BX)("div", {
                                className: "sticky bottom-0 left-0 right-0 bg-neutrals-0 py-2 px-4 lg:hidden",
                                children: [
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(atoms_button/* default */.Z, {
                                        size: types/* ButtonSize.LARGE */.q.LARGE,
                                        variant: types/* ButtonVariant.PRIMARY */.W.PRIMARY,
                                        className: "!w-full",
                                        onClick: ()=>setIsOpenContactForm(true),
                                        children: "Contactar"
                                    }),
                                    /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ModalForm, {
                                        closeModal: ()=>setIsOpenContactForm(false),
                                        isOpen: isOpenContactForm,
                                        children: flat ? /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(FormsTabs, {
                                            flat: flat,
                                            noTitle: true
                                        }) : /*#__PURE__*/ (0,jsx_runtime/* jsx */.tZ)(ContactForm, {})
                                    })
                                ]
                            })
                        ]
                    })
                })
            ]
        })
    });
};
ModalGallery.displayName = "ModalGallery";

;// CONCATENATED MODULE: ./components/atoms/modal-gallery/index.ts

/* harmony default export */ var modal_gallery = (ModalGallery);


/***/ })

}]);